import {Component, OnInit,} from '@angular/core';

import {LoginHelper} from '../../helpers';

import {Router} from '@angular/router';

import {AlertService, AuthenticationService, UserService,} from '../../_services/index';

import {User,} from '../../_models/index';


import {IndexConfigService} from "../../_services/index.config.service";
import {MatDialogRef} from '@angular/material/dialog';


@Component({
  standalone: false,
  selector: "document-folder-select",
  templateUrl: 'documentFolderSelect.component.html'
})

export class DocumentFolderSelect implements OnInit {
  model: any = {};
  loading = false;
  currentUser: User;
  folder: string = '';

  constructor(public dialogRef: MatDialogRef<DocumentFolderSelect>,
              public router: Router,
              public userService: UserService,
              public alertService: AlertService,
              //@Inject(FileManagerConfiguration) public configuration: IFileManagerConfiguration,
              public authenticationService: AuthenticationService,
              //public fileManagerDispatcher: FileManagerDispatcherService,
              public config: IndexConfigService) {

    //this.fileManagerDispatcher.unSelectAllFiles();
  }


  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    /*this.configuration.urls.foldersUrl = this.config.api + '/api/documents/foldersAll',
    this.configuration.urls.folderMoveUrl = this.config.api + '/api/documents/folderMove'
    this.configuration.urls.filesUrl = this.config.api + '/api/documents/filesAll';*/
  }

  onFolderSelected(folder) {
    this.folder = folder;
  }

  onDone() {
    this.dialogRef.close(this.folder);
  }

  onClose() {
    this.dialogRef.close();
  }
}
